module.exports = __webpack_public_path__ + "img/finland-respiratory-diseases-female.eeb87c6e.png";